var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":_vm.onClick}},[_c('i',{staticClass:"iconfont iconphysical"}),_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"btn"},[_vm._v("查看解析>>")])])])}
var staticRenderFns = []

export { render, staticRenderFns }